/**
 * 1.8.0: the Library's Rights quick filter (contracts RIGHTS_FILTERS; the saved-search key `rights`) and its chip.
 * Shown only while rights management is on. "Ends within N days" uses the workspace's ending-soon days.
 */
import { Check, X } from 'lucide-react';
import { DEFAULT_ENDING_SOON_DAYS, RIGHTS_FILTERS, rightsFilterLabel } from '@prism/contracts';
import { useRightsSettings } from '../../api/hooks/rights';
import type { LibraryFilterState } from './useLibraryFilters';

export function RightsFacet({ f }: { f: LibraryFilterState }) {
  const settings = useRightsSettings().data;
  if (!settings?.enabled) return null;
  const { filters, setFilters } = f;
  return (
    <div className="facet" data-testid="rights-filter">
      <h3>Rights</h3>
      {RIGHTS_FILTERS.map((k) => (
        <button key={k} className="facet-option" aria-pressed={filters.rights === k} onClick={() => setFilters((x) => ({ ...x, rights: x.rights === k ? null : k }))} data-testid={`rights-filter-${k}`}>
          <span className="check">{filters.rights === k && <Check size={11} strokeWidth={3} />}</span>
          {rightsFilterLabel(k, settings.endingSoonDays)}
        </button>
      ))}
    </div>
  );
}

export function RightsFilterChip({ f }: { f: LibraryFilterState }) {
  const settings = useRightsSettings().data;
  const k = f.filters.rights;
  if (!k || !settings?.enabled) return null;
  return (
    <span className="chip" key="rights" data-testid="rights-filter-chip">Rights: {rightsFilterLabel(k, settings.endingSoonDays ?? DEFAULT_ENDING_SOON_DAYS).toLowerCase()}
      <button aria-label="Remove filter Rights" onClick={() => f.setFilters((x) => ({ ...x, rights: null }))}><X size={12} /></button>
    </span>
  );
}
